import { TradingOfferTimelineStep } from '../../../types/TradingOffer';

export const tradingOfferTimelineKeys = {
  PUBLISHED: 'PUBLISHED',
  WAITING_ACCEPTANCE: 'WAITING_ACCEPTANCE',
  KYC_VERIFICATION: 'KYC_VERIFICATION',
  SOCIETY_VALIDATION: 'SOCIETY_VALIDATION',
  TRANSFER: 'TRANSFER',
} as const;

export const getDefaultTimelineSteps = (): TradingOfferTimelineStep[] => [
  {
    key: tradingOfferTimelineKeys.PUBLISHED,
    label: 'OfferPublished',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: tradingOfferTimelineKeys.WAITING_ACCEPTANCE,
    label: 'WaitingAcceptance',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: tradingOfferTimelineKeys.KYC_VERIFICATION,
    label: 'KYCVerification',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: tradingOfferTimelineKeys.SOCIETY_VALIDATION,
    label: 'SocietyValidation',
    isCompleted: false,
    isCurrent: false,
  },
  {
    key: tradingOfferTimelineKeys.TRANSFER,
    label: 'Transfer',
    isCompleted: false,
    isCurrent: false,
  },
];
